import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class AdministeredServiceModel extends BaseModel {
  @attr("datetime") createdAt;
  @attr("string") createdBy;
  @attr("datetime") updatedAt;
  @attr("string") updatedBy;
  @attr("string") serviceName;
  @attr("string") serviceCode;
}
